"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionManager = void 0;
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/share");
var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager(subscriptionClient) {
        var _this = this;
        this.subscriptionClient = subscriptionClient;
        this.hashSubscription = function (opts) {
            return JSON.stringify(opts.subOpts);
        };
        this.subscriptions = new Map();
        this.inMessages$ = new Subject_1.Subject();
        if (process.env.NODE_ENV === 'development' &&
            typeof window !== 'undefined' &&
            window.__app) {
            window.__app.subscriptions = function () { return _this.subscriptions; };
        }
    }
    Object.defineProperty(SubscriptionManager.prototype, "messages$", {
        get: function () {
            return this.inMessages$.asObservable().share();
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionManager.prototype.addSubscription = function (opts) {
        var _this = this;
        var hash = this.hashSubscription(opts);
        var subState = this.subscriptions.get(hash);
        if (subState) {
            subState.origins.push(opts.origin);
        }
        else {
            var subject = this.subscriptionClient.subscribe(opts.subOpts);
            var subscription = subject.subscribe(function (value) {
                return _this.inMessages$.next({
                    body: value,
                    opts: opts,
                });
            });
            var newSubState = {
                origins: [opts.origin],
                subscription: subscription,
            };
            this.subscriptions.set(hash, newSubState);
        }
    };
    SubscriptionManager.prototype.removeSubscription = function (opts) {
        var hash = this.hashSubscription(opts);
        var subState = this.subscriptions.get(hash);
        if (!subState)
            return;
        var firstOriginIdx = subState.origins.indexOf(opts.origin);
        // NOTE: filter first entry only
        subState.origins = subState.origins.filter(function (_, index) { return firstOriginIdx !== index; });
        if (subState.origins.length !== 0)
            return;
        if (subState.subscription) {
            subState.subscription.unsubscribe();
        }
        this.subscriptions.delete(hash);
    };
    return SubscriptionManager;
}());
exports.SubscriptionManager = SubscriptionManager;
//# sourceMappingURL=SubscriptionManager.js.map